<template>
  <v-dialog
    persistent
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
    width="850"
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Median Income (at 100% refund threshold)"
                v-model="selectedCountyMedian.MedianIncome"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Median Tax"
                v-model="selectedCountyMedian.MedianTax"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuCounty
                label="County"
                v-model="selectedCountyMedian.CountyId"
                :rules="[(v) => !!v || 'required']"
              ></LuCounty>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuPeriod
                label="Period"
                item-text="Period"
                v-model="selectedCountyMedian.PeriodId"
                :rules="[(v) => !!v || 'required']"
              ></LuPeriod>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveCountyMedianDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import CountyMedian from '@classes/CountyMedian'
//templateTODO: import lookup components you plan to use
import LuCounty from '@components/select/LuCounty/LuCounty-single'
import LuPeriod from '@components/select/LuPeriod/LuPeriod-single'
export default {
  components: {
    //templateTodo: define lookup components you are using
    LuCounty,
    LuPeriod,
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedCountyMedian: new CountyMedian(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('countyMedian', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('countyMedian', ['saveCountyMedian']),
    async validate() {
      await this.$refs.form.validate()
    },
    editCountyMedian(entry) {
      this.selectedCountyMedian = new CountyMedian(entry)
      this.modalText = 'Edit County Median'
      this.dialog = !this.dialog
    },
    addCountyMedian() {
      this.modalText = 'Insert County Median'
      this.selectedCountyMedian = new CountyMedian()
      this.dialog = !this.dialog
    },
    async saveCountyMedianDetails() {
      await this.validate()
      if (this.valid) {
        //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
        try {
          await this.saveCountyMedian(this.selectedCountyMedian.removeRelated())
          this.$emit('refresh')
          this.$emit('itemAdded', res.data)
          this.selectedCountyMedian = new CountyMedian()
          this.$refs.form.resetValidation()
        } catch (err) {}
        this.dialog = false
      }
    },
    cancelEntry() {
      this.dialog = false
      this.selectedCountyMedian = new CountyMedian()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
